exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marks[data-v-48cb32be]{position:relative;height:10px;margin:0 1px}.marks .mark--item[data-v-48cb32be]{position:absolute;transform:translateX(-50%);color:#999;font-size:12px;height:26px}.marks .mark--item[data-v-48cb32be]:after{position:absolute;height:6px;width:0;border-left:1px solid #999;left:50%;bottom:0;content:\" \"}", ""]);

// exports
